import { ref } from "vue"
import { defineStore, storeToRefs } from "pinia"
import type { Answers } from "@/features/voice/store/voice.types"
import { initAnswers } from "@/features/voice/store/voice.data"
import { useUserStore } from "@/stores/user"
import { useConfigStore } from "@/stores/config"
import { restartVoice } from "@/api/viktor/assessment/assessment"

export const useAnswersStore = defineStore("voiceAnswersStore", () => {
  const configStore = useConfigStore()
  const userStore = useUserStore()
  const { getUserUuid, getVoiceUuid } = storeToRefs(userStore)
  const { nextAssessment, getVoiceByUuid } = storeToRefs(userStore)

  const answers = ref<Answers>(initAnswers)

  const selectedMicrophoneId = ref<string>(
    localStorage.getItem("selectedMicrophoneId") || ""
  )
  const selectedSpeakerId = ref<string>(
    localStorage.getItem("selectedSpeakerId") || ""
  )

  // GETTERS

  async function fetchVoice() {
    const nextAssessmentName = nextAssessment.value?.next_assessment?.assessment
    // Si pas de voice de prévu, on retourne au stepper
    if (nextAssessmentName !== "voice") {
      document.location.href = configStore.urls.app
    }

    return getVoiceByUuid.value(getVoiceUuid.value)
  }

  // ACTIONS

  const setMicrophoneId = (id: string) => {
    selectedMicrophoneId.value = id
    localStorage.setItem("selectedMicrophoneId", id)
  }

  const setSpeakerId = (id: string) => {
    selectedSpeakerId.value = id
    localStorage.setItem("selectedSpeakerId", id)
  }

  async function retakeTest() {
    await restartVoice(getUserUuid.value, getVoiceUuid.value)
    // await userStore.fetchStepper() @todo: ?
    await userStore.fetchAssessmentSummary()
  }

  return {
    answers,
    fetchVoice,
    retakeTest,
    selectedMicrophoneId,
    selectedSpeakerId,
    setMicrophoneId,
    setSpeakerId,
  }
})
